export const CONTRACT_SELECTED = 'CONTRACT_SELECTED';

export const CONTRACT_RESET = 'CONTRACT_RESET';

export function contractSelected(contractId: string, id: string) {
  return {
    type: CONTRACT_SELECTED,
    payload: {
      contractId,
      id,
    },
  } as const;
}

export function contractReset() {
  return {
    type: CONTRACT_RESET,
    payload: {},
  } as const;
}

export type SelectedContractAction = ReturnType<typeof contractSelected> | ReturnType<typeof contractReset>;
